import React from "react";
import { Card, Input, Button, Form, notification, Col } from "antd";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../services/util";

function ChangePassword() {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem("x-dashboard-staffid");

    async function handleChangePasswordSubmit(values) {
        values.old_password = encrypt(values.old_password);
        values.new_password = encrypt(values.new_password);
        values.confirm_password = encrypt(values.confirm_password);
        const { message, success } = await HTTP("/users/changePassword", {
            ...values,
            staff_id,
        });
        if (!success) {
            notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: message,
            });
            navigate("/");
        }
    }

    return (
        <div className="forget-container">
            <Card bordered={false} className="forget-card">
                <Col md={12}>
                    <div>
                        <img
                            src={logoImage}
                            alt="dashboard"
                            className="forget-dashboard-vector"
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <div className="forget-contents">
                        <div className="title-container">Change Password</div>
                        <div className="description-container">
                            Please set new password.
                        </div>
                        <div className="forget-inputs">
                            <Form
                                layout="vertical"
                                onFinish={handleChangePasswordSubmit}
                            >
                                <Form.Item name="old_password" required={true}>
                                    <Input.Password
                                        autoFocus
                                        id="old_password"
                                        size="large"
                                        placeholder="Old Password"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="new_password"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please enter your password.",
                                        },
                                        {
                                            pattern:
                                                /^(?=.*\d)(?=.*[~!@#$%^&*()\-_=+<>,.?/;:"'{}|\\[\]])(?!.*\s)(?=.*[A-Z])(?=.*[a-z]).{8,16}$/,
                                            message:
                                                "Password must be 8-16 characters long and contain at least one lowercase letter, one uppercase letter, one special character and a number.",
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        id="new_password"
                                        size="large"
                                        type="password"
                                        placeholder="Password"
                                        className="change-background"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="confirm_password"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please confirm your password.",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(rule, value) {
                                                if (
                                                    !value ||
                                                    getFieldValue(
                                                        "new_password",
                                                    ) === value
                                                ) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    "Password does not match.",
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        size="large"
                                        type="password"
                                        placeholder="Confirm Password"
                                        className="change-background"
                                    />
                                </Form.Item>

                                <div className="button-link-container">
                                    <Button type="primary" htmlType="submit">
                                        Change Password
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Card>
        </div>
    );
}

export { ChangePassword };
